import * as React from "react";
import { forwardRef } from "react";
const SvgIcChevronDown24 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.0001 13.9393L18.7501 7.18934L20.0608 8.5L12.5304 16.0303H11.4698L3.93945 8.5L5.25011 7.18934L12.0001 13.9393Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcChevronDown24);
export { ForwardRef as ReactComponent };
